import React, { useState } from "react";
import JobCard from "../components/JobCard";
import "../styles/Jobs.css";

const Jobs = () => {
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("All");
  const [location, setLocation] = useState("All");
  const [sortBy, setSortBy] = useState("Latest");

  const jobs = [
    { id: 1, title: "Software Engineer", company: "Google", location: "Remote", salary: "₹15 LPA", logo: "/images/google.png", posted: "2024-02-20" },
    { id: 2, title: "Data Scientist", company: "Amazon", location: "Bangalore", salary: "₹20 LPA", logo: "/images/amazon.png", posted: "2024-02-18" },
    { id: 3, title: "Frontend Developer", company: "Microsoft", location: "Hyderabad", salary: "₹12 LPA", logo: "/images/microsoft.png", posted: "2024-02-19" },
    { id: 4, title: "AI Engineer", company: "Tesla", location: "Pune", salary: "₹22 LPA", logo: "/images/tesla.png", posted: "2024-02-15" },
  ];

  const filteredJobs = jobs
    .filter((job) =>
      (filter === "All" || job.company === filter) &&
      (location === "All" || job.location === location) &&
      job.title.toLowerCase().includes(search.toLowerCase())
    )
    .sort((a, b) => (sortBy === "Salary" ? parseInt(b.salary) - parseInt(a.salary) : new Date(b.posted) - new Date(a.posted)));

  return (
    <div className="jobs-page">
      <h1>Find Your Dream Job</h1>

      {/* Search & Filters */}
      <div className="filters">
        <input
          type="text"
          placeholder="Search by job title..."
          onChange={(e) => setSearch(e.target.value)}
        />
        <select onChange={(e) => setFilter(e.target.value)}>
          <option value="All">All Companies</option>
          <option value="Google">Google</option>
          <option value="Amazon">Amazon</option>
          <option value="Microsoft">Microsoft</option>
          <option value="Apple">Apple</option>
          <option value="Tesla">Netflix</option>
          <option value="Tesla">TCS</option>
          <option value="Tesla">Zoho</option>
          <option value="Tesla"></option>
          <option value="Tesla">Tesla</option>
          <option value="Tesla">Tesla</option>
          <option value="Tesla">Tesla</option>
          <option value="Tesla">Tesla</option>
        </select>

        <select onChange={(e) => setLocation(e.target.value)}>
          <option value="All">All Locations</option>
          <option value="Remote">Remote</option>
          <option value="Bangalore">Bangalore</option>
          <option value="Hyderabad">Hyderabad</option>
          <option value="Pune">Pune</option>
        </select>

        <select onChange={(e) => setSortBy(e.target.value)}>
          <option value="Latest">Sort by Latest</option>
          <option value="Salary">Sort by Salary</option>
        </select>
      </div>

      {/* Job Listings */}
      <div className="jobs-list">
        {filteredJobs.length > 0 ? (
          filteredJobs.map((job) => <JobCard key={job.id} job={job} />)
        ) : (
          <p className="no-jobs">No jobs found.</p>
        )}
      </div>
    </div>
  );
};

export default Jobs;
